/**
 * Google Ads conversion tracking (gtag.js)
 * Only loads in production builds.
 */

export const initializeGoogleAds = (): void => {
  const googleAdsId = import.meta.env.VITE_GOOGLE_ADS_ID

  if (!googleAdsId || googleAdsId.trim() === '') {
    return
  }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments as unknown as Record<string, unknown>)
  }
  window.gtag('js', new Date())
  window.gtag('config', googleAdsId)
}

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}
